<div id="bubble-chart">
</div>
<div *ngIf="haveLegend" class="container legend-container">
    <div class="row">
        <div class="col">
            <ng-container *ngFor="let left of legendList.left">
                <span class="dot" [ngStyle]="{backgroundColor: left.color }"></span> <span class="left-legend-text td-legend">{{left.name}}</span><br/>
            </ng-container>
        </div>
        <div class="col-2"></div>
        <div class="col">
            <ng-container *ngFor="let right of legendList.right">
                <span class="dot" [ngStyle]="{backgroundColor: right.color }"></span> <span class="right-legend-text td-legend">{{right.name}}</span><br/>
            </ng-container>
        </div>
      </div>
</div>
